/** Salary tab UI tokens (blue / sky — no bright green). */
export const SALARY_THEME = {
  header: 'from-slate-700 via-slate-700 to-sky-800',
  topStripe: 'from-blue-600 via-sky-500 to-blue-400',
  subNavWrap:
    'inline-flex w-full sm:w-auto p-1.5 bg-gradient-to-r from-blue-50 via-slate-50 to-sky-50 border border-blue-100 rounded-xl shadow-sm',
  subNavActive: 'bg-gradient-to-r from-blue-600 to-sky-500 text-white shadow-md',
  subNavIdle: 'text-gray-600 hover:text-blue-700 hover:bg-white/90',
  subNavBadgeActive: 'bg-white/25 text-white',
  subNavBadgeIdle: 'bg-blue-100 text-blue-700',
  sectionStripe: 'bg-blue-600',
  sectionLabel: 'text-blue-800',
  fieldFocus: 'focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/30',
  earningsCard: 'border-sky-100 bg-gradient-to-br from-sky-50/70 to-white',
  earningsTitle: 'text-sky-900',
  earningsText: 'text-sky-700',
  earningsMuted: 'text-sky-300',
  earningsStat: 'text-sky-600',
  earningsStatValue: 'text-sky-800',
  netBadge: 'bg-sky-100 text-sky-900',
  avatar: 'from-blue-500 to-sky-400',
  groupRow: 'bg-blue-50/90',
  groupLabel: 'text-blue-900',
  groupSub: 'text-blue-700',
  hoverRow: 'hover:bg-blue-50/40',
  filterFocus: 'focus:border-blue-500 focus:ring-blue-500',
  emptyBg: 'bg-blue-100',
  emptyIcon: 'text-blue-500',
  btnPrimary:
    'inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-blue-600 to-sky-500 px-5 py-2.5 text-sm font-semibold text-white shadow-md hover:brightness-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
  btnSecondary:
    'rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50',
  btnAddLine:
    'inline-flex items-center gap-1 rounded-lg bg-gradient-to-r from-blue-600 to-sky-500 px-2.5 py-1 text-xs font-semibold text-white shadow-sm hover:brightness-105',
  exportBtn:
    'inline-flex items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-blue-50 hover:border-blue-200 hover:text-blue-800 transition-colors',
  modalHeader: 'from-slate-700 via-slate-700 to-sky-800',
};

export const PAYMENT_MODE_BADGE_STYLES = {
  Cash: 'bg-slate-100 text-slate-800 ring-slate-200',
  'Bank Transfer': 'bg-blue-100 text-blue-800 ring-blue-200',
  UPI: 'bg-violet-100 text-violet-800 ring-violet-200',
  Cheque: 'bg-amber-100 text-amber-800 ring-amber-200',
  Card: 'bg-slate-100 text-slate-700 ring-slate-200',
  Other: 'bg-gray-100 text-gray-700 ring-gray-200',
};
